<template>
  <div class="home">
    <HeroSection />
    <ServicesSection />
    <AboutSection />
    <FeaturedProducts />
  </div>
</template>

<script setup lang="ts">
import HeroSection from '@/components/sections/HeroSection.vue'
import ServicesSection from '@/components/sections/ServicesSection.vue'
import AboutSection from '@/components/sections/AboutSection.vue'
import FeaturedProducts from '@/components/sections/FeaturedProducts.vue'
</script>

<style scoped>
.home {
  padding: 0;
  min-height: 100vh;
}
</style>
